import { StyleSheet } from "react-native";
import { Theme } from "../../theme-provider";

const listContentStyle = (theme: Theme) => StyleSheet.create({
    container: {
        flexDirection: 'row',
        paddingVertical: theme.spacing.half,
        paddingLeft: theme.spacing.half,
        paddingRight: theme.spacing.half,
        height: theme.units.base * 6.4,
        alignContent: 'center',
    },
    compactContainer: {
        height: 56,
        paddingVertical: 8,
    },
    iconContainer: {
        aspectRatio: 1 / 1,
        height: '100%',
        marginRight: theme.spacing.half,
        backgroundColor: theme.color.background,
        borderRadius: theme.borderRadius.medium,
        borderWidth: 3,
        borderColor: theme.color.mapIcons,
        justifyContent: 'center' as const,
        alignItems: 'center' as const,
    },
    // POI rows: same design as paths but filled with the map-icon blue.
    iconContainerPoi: {
        backgroundColor: theme.color.mapIcons,
        borderColor: theme.color.mapIcons,
    },
    // Event rows: same design as paths but in the lighter header blue.
    iconContainerEvent: {
        backgroundColor: theme.color.background,
        borderColor: theme.color.listBackgroundInverted,
    },
    categoryIcon: {
        width: '90%',
        height: '90%',
        color: theme.color.mapIcons,
    },
    // Glyph on a filled POI icon container.
    categoryIconInverted: {
        color: theme.color.textInverted,
    },
    // Glyph on an event icon container (dark blue on white with a light blue border).
    categoryIconEvent: {
        color: theme.color.mapIcons,
    },
    content: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    title: {
        fontSize: theme.fontSize.medium,
        color: theme.color.textPrimary,
    },
    subtitle: {
        fontSize: theme.fontSize.small,
        color: theme.color.textPrimary,
        opacity: 1,
        flexWrap: 'nowrap',
        paddingRight:  theme.spacing.half,
    },
    length: {
        fontSize: theme.fontSize.medium,
        color: theme.color.textSecondary,
    },
    status: {
        fontSize: theme.fontSize.small,
        color: theme.color.textSecondary,
        textAlign: 'right',
    },
    difficultyIcon: {
        height: theme.iconSize.medium,
        width: theme.iconSize.medium,
        marginRight: theme.spacing.half,
    },
    count: {
        marginLeft: 'auto',
        fontSize: theme.fontSize.medium,
        color: theme.color.mapIcons,
    },
    flexRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    row: {
        justifyContent: 'space-between',
        marginBottom: theme.spacing.sliver,
    },
    nameWrapper: {
        width: '70%',
    },
});

export { listContentStyle };